import { useBreadcrumbs } from "../../core/hooks/use-breadcrumbs.js";
import { Breadcrumbs } from "@tecsinapse/cortex-react";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/header/components/custom-breadcrumbs.tsx
var CustomBreadcrumbs = () => {
	const { crumbs } = useBreadcrumbs();
	return /* @__PURE__ */ jsx("div", {
		className: "max-w-360 w-[calc(100%-32px)] my-deca mx-auto hidden sm:flex",
		children: /* @__PURE__ */ jsx(Breadcrumbs, { breadcrumbs: crumbs })
	});
};
//#endregion
export { CustomBreadcrumbs };
